import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { IconButton } from '@dhl-ui/components'
import { SearchIcon } from '@dhl-ui/icons'

type Props = {
  onClick?: () => void
}

export const SearchButton: FC<Props> = ({ onClick }) => {
  const { t } = useTranslation()

  return (
    <IconButton
      aria-label={t('components.inputs.search.searchButtonText')}
      data-testid="search-button"
      size="small"
      variant="ghost"
      onClick={onClick}
    >
      <SearchIcon />
    </IconButton>
  )
}
